import { createContext, useContext, useState, ReactNode} from 'react';
import { userType } from '../../generalType/UserType';

interface UserContextType {
    userData: userType | null;
    setUserData: (userData: userType  | null) => void;
    theme: string,
    setTheme: (theme:string) => void,
}
const userContextInfo = createContext<UserContextType>({
    userData: null,
    setUserData: () => {},
    theme: "",
    setTheme: ()=>{},
});

interface PersonProviderProps {
  children: ReactNode;
}


export const UserProvider = ({ children} :PersonProviderProps)=>{
    const [userData, setUserData] = useState<userType | null>(null);
    const localRole = localStorage.getItem("theme");
    const [theme, setTheme] = useState<string>(localRole || "client")
    localStorage.setItem("theme", theme);
    return(
        <userContextInfo.Provider value={{userData: userData, setUserData: setUserData, theme: theme, setTheme: setTheme}}>
            {children}
        </userContextInfo.Provider>
    )
}

export const UserConsumer = ()=>{
    return useContext(userContextInfo);
}
